import React, { useEffect, useState } from 'react';

import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardHeaderTitle,
  CardHeaderIcon,
  Columns,
  Column,
  MuiTitle,
} from 'src/ui/mui-ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { fetchLoggedInUser, getUser } from 'src/user';
import { fetchAccount, getAccount } from 'src/account';
import { getToken } from 'src/auth';
import { toast } from 'react-toastify';
import {
  fetchComplianceSettings,
  getComplianceSettings,
  updateComplianceSettings,
  updateComplianceSetting,
  updateComplianceEmails,
} from 'src/compliance';

import { InnerLoader, UiToastAdapter, UiSpacer } from 'src/ui';
import propTypes from 'prop-types';
import {
  EditAllComplianceForm,
  ComplianceTaskAccountTable,
  AccountTaskModal,
  ComplianceTaskEmailTable,
} from '../components';
import { COMPLIANCE_TASK_TYPE } from '../const';
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-syntax */

const GRATUITY = 'Gratuity Check';
const LICENSE = 'License Expiration Check';
const BACKGROUND = 'Background Check';

const DOCUMENT = 'Document Expiration Check';
const PROCESSING = 'Account Processing Check';

const SAR = 'SAR Expiration Check Notification';
const CHANGE = 'Account Change Check';

const SETTING_TYPES = {
  [GRATUITY]: { settingType: 'Gratuity' },
  [LICENSE]: { settingType: 'License' },
  [BACKGROUND]: { settingType: 'Background' },

  [DOCUMENT]: { settingType: 'Document' },
  [PROCESSING]: { settingType: 'Processing' },
  [SAR]: { settingType: 'Sar' },
  [CHANGE]: { settingType: 'Change' },
};

function ComplianceSettingsPage({
  user,
  token,
  fetchComplianceSettings,
  updateComplianceSettings,
  updateComplianceSetting,
  updateComplianceEmails,
  settings,
}) {
  const initTaskModalState = {
    isActive: false,
    data: {},
    type: '',
    formType: '',
    taskType: '',
  };
  const initEmailModalState = {
    isActive: false,
    data: [],
    taskId: -1,
    accountName: '',
  };

  const [loading, setLoading] = useState(true);
  const [accountTaskModal, setAccountTaskModal] = useState(initTaskModalState);
  const [emailTaskModal, setEmailTaskModal] = useState(initEmailModalState);
  const onCancel = form => {
    form.reset();
    setAccountTaskModal(initTaskModalState);
  };

  const onEmaiCancel = form => {
    form.reset;
    setEmailTaskModal(initEmailModalState);
  };
  async function handleSubmitAll(data, type) {
    await updateComplianceSettings({
      financialInstitutionId: user.financialInstitutionId,
      enableAll: data.enableAll,
      disableAll: data.disableAll,
      addAllFIAdmin: data.addAllFIAdmin,
      addEmails: data.addEmails?.map(e => e.value),
      deleteEmails: data.deleteEmails?.map(e => e.email),
      taskFrequency: data.taskFrequency?.label,
      gratuityTolerance: data.tolerance,
      taskType: COMPLIANCE_TASK_TYPE[type],
    }).then(response =>
      response.error
        ? toast(
            UiToastAdapter(
              'An Error Occured While Updating Compliance Settings',
              'danger'
            )
          )
        : toast(
            UiToastAdapter(
              'Compliance Settings Successfully Updated',
              'success'
            )
          )
    );
  }
  async function handleSubmit(data, taskId) {
    setAccountTaskModal(initTaskModalState);
    await updateComplianceSetting({
      financialInstitutionId: user.financialInstitutionId,
      taskId,
      isActive: data.isActive,
      addEmails: data.addEmails?.map(e => e.value),
      deleteEmails: data.deleteEmails?.map(e => e.email),
      taskFrequency: data.taskFrequency?.label,
      gratuityTolerance: data.tolerance,
    }).then(response =>
      response.error
        ? toast(
            UiToastAdapter(
              'An Error Occured While Updating Compliance Settings',
              'danger'
            )
          )
        : toast(
            UiToastAdapter(
              'Compliance Settings Successfully Updated',
              'success'
            )
          )
    );
    setLoading(false);
  }

  async function handleUpdateEmails(data, taskId) {
    setEmailTaskModal(initEmailModalState);
    const newData = {};
    for (const [key, val] of Object.entries(data)) {
      const setting = key.slice(0, key.lastIndexOf('_'));
      const id = key.slice(key.lastIndexOf('_') + 1);

      if (!newData[id]) {
        newData[id] = {};
      }
      newData[id][setting] = val;
    }

    await updateComplianceEmails({
      financialInstitutionId: user.financialInstitutionId,
      data: newData,
      taskId,
    }).then(response =>
      response.error
        ? toast(
            UiToastAdapter(
              'An Error Occured While Updating Compliance Settings',
              'danger'
            )
          )
        : toast(
            UiToastAdapter(
              'Compliance Settings Successfully Updated',
              'success'
            )
          )
    );

    setLoading(false);
  }
  useEffect(() => {
    (async () => {
      setLoading(true);
      if (token.isValid()) {
        await fetchComplianceSettings({
          financialInstitutionId: user.financialInstitutionId,
        }).then(() => setLoading(false));
      }
    })();
  }, []);

  return (
    <>
      <MuiTitle isSize="4" hasTextColor="info" tag="h2">
        Compliance Settings
      </MuiTitle>
      {!settings.isLoading() && !loading ? (
        Object.keys(SETTING_TYPES).map((key, idx) => (
          <div key={idx}>
            <ComplianceSetting
              type={key}
              data={settings}
              handleSubmitAll={handleSubmitAll}
              setAccountTaskModal={setAccountTaskModal}
              setEmailTaskModal={setEmailTaskModal}
            />
            <UiSpacer />
          </div>
        ))
      ) : (
        <InnerLoader visible />
      )}
      <AccountTaskModal
        isActive={accountTaskModal.isActive}
        onCancel={onCancel}
        formType={accountTaskModal.formType}
        data={accountTaskModal.data}
        taskType={accountTaskModal.taskType}
        onSubmit={handleSubmit}
      />
      <ComplianceTaskEmailTable
        isActive={emailTaskModal.isActive}
        data={emailTaskModal.data}
        taskId={emailTaskModal.taskId}
        onCancel={onEmaiCancel}
        handleUpdateEmails={handleUpdateEmails}
        accountName={emailTaskModal.accountName}
      />
    </>
  );
}

function ComplianceSetting({
  type,
  data,
  handleSubmitAll,
  setAccountTaskModal,
  setEmailTaskModal,
}) {
  const [showCard, setShowCard] = useState(false);
  const [showManageAccounts, setShowManageAccounts] = useState(false);
  const { settingType } = SETTING_TYPES[type];
  const { tasks, emailList } = data[settingType];
  return (
    <Card>
      <CardHeader>
        <CardHeaderIcon onClick={() => setShowCard(!showCard)}>
          <FontAwesomeIcon
            icon={showCard ? ['fal', 'angle-down'] : ['fal', 'angle-up']}
            size="2x"
          />
        </CardHeaderIcon>
        <CardHeaderTitle>{type}</CardHeaderTitle>
      </CardHeader>
      {showCard && (
        <CardContent>
          <Columns>
            <Column isSize="1/2">
              <MuiTitle
                tag="h4"
                size="4"
              >{`Change ${type} for ${tasks.length} Account(s)`}</MuiTitle>
            </Column>
            <Column isSize="1/2" hasTextAlign="right">
              <Button
                onClick={() => setShowManageAccounts(!showManageAccounts)}
                isColor="gradient-bright"
              >
                Manage Accounts
              </Button>
            </Column>
          </Columns>
          <EditAllComplianceForm
            data={tasks}
            type={settingType}
            emailList={emailList}
            title={type}
            handleSubmitAll={handleSubmitAll}
          />
          {showManageAccounts && (
            <>
              {/* <Column isSize="full" hasTextAlign="right">
                <Button
                  // onClick={() => setShowManageAccounts(!showManageAccounts)}
                  isColor="gradient-bright"
                >
                  Add Account
                </Button>
              </Column> */}
              <ComplianceTaskAccountTable
                data={tasks}
                type={settingType}
                setAccountTaskModal={setAccountTaskModal}
                setEmailTaskModal={setEmailTaskModal}
              />
            </>
          )}
        </CardContent>
      )}
    </Card>
  );
}

function mapStateToProps(state) {
  return {
    user: getUser(state),
    token: getToken(state),
    account: getAccount(state),
    settings: getComplianceSettings(state),
  };
}
const connectedComplianceSettingsPage = connect(mapStateToProps, {
  fetchLoggedInUser,
  fetchAccount,
  fetchComplianceSettings,
  updateComplianceSettings,
  updateComplianceSetting,
  updateComplianceEmails,
})(ComplianceSettingsPage);

export { connectedComplianceSettingsPage as ComplianceSettingsPage };

ComplianceSettingsPage.propTypes = {
  user: propTypes.object.isRequired,
  token: propTypes.object.isRequired,
  fetchComplianceSettings: propTypes.func.isRequired,
  updateComplianceSettings: propTypes.func.isRequired,
  updateComplianceSetting: propTypes.func.isRequired,
  settings: propTypes.object.isRequired,
  updateComplianceEmails: propTypes.func.isRequired,
};

ComplianceSetting.propTypes = {
  type: propTypes.string.isRequired,
  data: propTypes.object.isRequired,
  handleSubmitAll: propTypes.func.isRequired,
  setAccountTaskModal: propTypes.func.isRequired,
  setEmailTaskModal: propTypes.func.isRequired,
};
